import React from 'react';

import type KitElement from '@this/domain/kit_element/kit_element2';
import { observer } from 'mobx-react';

interface Props {
  element: KitElement;
  classNameForModifiedField: (...path: (string | number)[]) => string;
}

type TypeKind = 'PCR検査キット' | 'PCR検査キット(一括購入)';
type ProductName = '新型コロナ抗原検査キット';

const KindOptions: TypeKind[] = ['PCR検査キット', 'PCR検査キット(一括購入)'];
const NameOptions: ProductName[] = ['新型コロナ抗原検査キット'];

const KitElementForm = ({ element, classNameForModifiedField }: Props) => (
  <>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('kind')}`}>
        種別
      </label>
      <select
        value={element.kind}
        onChange={e => {
          element.kind = e.target.value;
        }}
      >
        {KindOptions.map(v => (
          <option key={v} value={v}>
            {v}
          </option>
        ))}
      </select>
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('name')}`}>
        商品名
      </label>
      <select
        value={element.name}
        onChange={e => {
          element.name = e.target.value;
        }}
      >
        {NameOptions.map(v => (
          <option key={v} value={v}>
            {v}
          </option>
        ))}
      </select>
    </div>

    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('kitSize')}`}>
        数量
      </label>
      <input
        type="number"
        value={element.kitSize}
        onChange={e => {
          element.kitSize = parseInt(e.target.value, 10);
        }}
      />
    </div>

    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('stockNumber')}`}>
        在庫管理番号
        <span className="red">（必須）</span>
      </label>
      <input
        type="text"
        value={element.stockNumber}
        onChange={e => {
          element.stockNumber = e.target.value;
        }}
      />
    </div>

    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('lotNumber')}`}>
        ロット管理番号
      </label>
      <input
        type="text"
        value={element.lotNumber}
        onChange={e => {
          element.lotNumber = e.target.value;
        }}
      />
    </div>

    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('remark')}`}>
        備考
      </label>
      <textarea
        value={element.remark}
        onChange={e => {
          element.remark = e.target.value;
        }}
      />
    </div>
  </>
);
export default observer(KitElementForm);
